export enum FurnitureOption {
    UNKNOWN = 0,
    NO = 1,
    KITCHEN = 2,
    ALL = 3
}
